import { el, progress } from '../dom.js';
import { copy } from '../copy.js';

export function renderIntro(state, actions) {
  const { goto } = actions;
  return el('div', { class: 'screen' }, [
    progress({ step: 0, total: 4 }),
    el('h1', { text: copy.intro.title }),
    el('p', { text: copy.intro.body }),
    copy.intro.heroSrc
      ? el('img', {
          class: 'intro-hero',
          src: copy.intro.heroSrc,
          alt: copy.intro.heroAlt ?? '',
        })
      : null,
    el('div', { class: 'actions' }, [
      el('button', {
        class: 'primary',
        text: copy.intro.start,
        onClick: () => goto('modem'),
      }),
    ]),
  ]);
}
